import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

axios.defaults.headers.post['Content-Type'] = 'application/json';

// Acción para obtener los datos de riego de un nodo
export const riegoNodo = createAsyncThunk(
    'riegoNodo/getRiegoNodo',
    async ({ lat, lon }) => {
        try {
            const response = await axios.get("/api/sensor/getRiegoNodo", {
                params: {
                    lat,
                    lon
                }
            });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);